import React, { useState, useEffect } from "react";
import ModalVideo from "../common/ModalVideo";
import { extractProviderAndVideoId } from "../../utils/extractProviderAndVideoId";

interface VideoStandardProps {
  elementId?: string;
  cssClass?: string;
  start?: string;
  url: string;
  vidImg?: string;
}

const disableScroll = (): void => {
  document.body.style.overflow = "hidden";
};

const enableScroll = (): void => {
  document.body.style.overflow = "auto";
};

const VideoStandard: React.FC<VideoStandardProps> = ({
  elementId = "",
  cssClass,
  start = "",
  url,
  vidImg,
}) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const trimmedUrl = url.trim();
  const videoDetails = extractProviderAndVideoId(trimmedUrl);

  useEffect(() => {
    if (isOpen) {
      disableScroll();
    } else {
      enableScroll();
    }

    return () => {
      enableScroll();
    };
  }, [isOpen]);

  return (
    <div id={elementId} className={`container ${cssClass} mb--50`}>
      <div className="row">
        <div className="col-lg-12">
          <div className="inner-wrapper">
            <div className="inner">
              <div className="embed-responsive-small video-wrapper position-relative mb--40">
                <div className="thumbnail">
                  <img
                    src={
                      vidImg ??
                      `https://img.youtube.com/vi/${videoDetails.videoId}/maxresdefault.jpg`
                    }
                    alt="user Uploads"
                  />
                </div>
                {videoDetails.provider === "youtube" &&
                  videoDetails.videoId && (
                    <ModalVideo
                      channel="youtube"
                      isOpen={isOpen}
                      videoId={videoDetails.videoId}
                      start={start}
                      onClose={() => setOpen(false)}
                    />
                  )}
                {videoDetails.provider === "vimeo" && videoDetails.videoId && (
                  <ModalVideo
                    channel="vimeo"
                    isOpen={isOpen}
                    videoId={videoDetails.videoId}
                      start={start}
                    onClose={() => setOpen(false)}
                  />
                )}
                <button
                  type="button"
                  className="video-popup position-top-center"
                  onClick={() => setOpen(true)}
                  aria-label="Text Label"
                >
                  <span className="play-icon" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoStandard;
